import { render, staticRenderFns } from "./ClientsNotebookPage.vue?vue&type=template&id=53e234cf"
import script from "./ClientsNotebookPage.vue?vue&type=script&lang=js"
export * from "./ClientsNotebookPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports